import Login from "../Views/Login";
import Dashboard from "../Views/Dashboard";
import Roles from "../Views/Roles";
import Users from "../Views/Users";
import UserCreateEdit from "../Views/Users/createEdit";
import Settings from "../Views/Settings";
import RingCentral from "../Views/RingCentral";
import Calendar from "../Views/Calendar";
import Crew from "../Views/Crew";
import TimeLogs from "../Views/TimeLogs";
import MyProfile from "../Views/MyProfile";
import WebsiteData from "../Views/WebsiteData";
import Trace from "../Views/Trace";
import Crm from "../Views/crm";
import LeadCost from "../Views/website/LeadCost";
import DummyReport from "../Views/DummyReport";
import Estimates from "../Views/Estimates";
import GoogleReportDetailPage from "../Views/GoogleReports/DetailPage";
import EstimatesTemplatesPage from "../Views/Estimates/EstimatesTemplatesPage";
import EstimatesCategoryPage from "../Views/Estimates/EstimatesCategoryPage";
import CreateTemplatePage from "../Views/Estimates/CreateTemplatePage";
import GoogleReports from "../Views/GoogleReports";
// Add this import at the top with the others
import GoogleOAuthCallback from "../Views/Settings/GoogleOAuthCallback";

export const baseRoutes = [
	{
		name: 'Home',
		path: '/',
		component: <Login />
	},
	 {
    name: 'Google OAuth Callback',
    path: '/google/oauth/callback',
    component: <GoogleOAuthCallback />
  }
];

export const authSuperAdminRoutes = [
	{
		name: 'CRM',
		path: '/crm',
		component: <Crm />
	},
	{
		name: 'Estimates',
		path: '/estimates',
		component: <Estimates />
	},
	{
		name: 'Estimates Templates',
		path: '/estimates/templates',
		component: <EstimatesTemplatesPage />
	},
	{
		name: 'Estimates Category',
		path: '/estimates/category',
		component: <EstimatesCategoryPage />
	},
	{
		name: 'Create Template',
		path: '/estimates/templates/create',
		component: <CreateTemplatePage />
	},
	{
		name: 'Edit Template',
		path: '/estimates/templates/edit/:id',
		component: <CreateTemplatePage />
	},
	{
		name: 'Super Admin Dashboard',
		path: '/dashboard',
		component: <Dashboard />
	},
	{
		name: 'Roles',
		path: '/roles',
		component: <Roles />
	},
	{
		name: 'Users',
		path: '/users',
		component: <Users />
	},
	{
		name: 'Users',
		path: '/users/create',
		component: <UserCreateEdit />
	},
	{
		name: 'Users',
		path: '/users/edit/:id',
		component: <UserCreateEdit />
	},
	{
		name: 'Settings',
		path: '/settings',
		component: <Settings />
	},
	{
		name: 'Ring Central',
		path: '/ring-central',
		component: <RingCentral />
	},
	{
		name: 'Calendar',
		path: '/calendars',
		component: <Calendar />
	},
	{
		name: 'Trace',
		path: '/trace',
		component: <Trace />
	},
	{
		name: 'Crew',
		path: '/crew',
		component: <Crew />
	},
	{
		name: 'TimeLogs',
		path: '/time-logs',
		component: <TimeLogs />
	},
	{
		name: 'MyProfile',
		path: '/profile',
		component: <MyProfile />
	},
	{
		name: 'Marketing Report',
		path: '/marketing-report',
		component: <WebsiteData />
	},
	{
		name: 'Lead Cost',
		path: '/lead-cost',
		component: <LeadCost />
	},
	{
		name: 'Dummy Report',
		path: '/dummy-report',
		component: <DummyReport />
	},
	{
		name: 'GA / GSC',
		path: '/google-reports',
		component: <GoogleReports />
	},
	{
		name: 'User Acquisition',
		path: '/google-reports/user-acquisition',
		component: <GoogleReportDetailPage />
	},
	{
		name: 'Events',
		path: '/google-reports/events',
		component: <GoogleReportDetailPage />
	},
	{
		name: 'Landing Pages',
		path: '/google-reports/landing-pages',
		component: <GoogleReportDetailPage />
	},
];

export const authAdminRoutes = [
	{
		name: 'CRM',
		path: '/crm',
		component: <Crm />
	},
	{
		name: 'Estimates',
		path: '/estimates',
		component: <Estimates />
	},
	{
		name: 'Estimates Templates',
		path: '/estimates/templates',
		component: <EstimatesTemplatesPage />
	},
	{
		name: 'Estimates Category',
		path: '/estimates/category',
		component: <EstimatesCategoryPage />
	},
	{
		name: 'Create Template',
		path: '/estimates/templates/create',
		component: <CreateTemplatePage />
	},
	{
		name: 'Edit Template',
		path: '/estimates/templates/edit/:id',
		component: <CreateTemplatePage />
	},
	{
		name: 'Admin Dashboard',
		path: '/dashboard',
		component: <Dashboard />
	},
	{
		name: 'Roles',
		path: '/roles',
		component: <Roles />
	},
	{
		name: 'Users',
		path: '/users',
		component: <Users />
	},
	{
		name: 'Users',
		path: '/users/create',
		component: <UserCreateEdit />
	},
	{
		name: 'Users',
		path: '/users/edit/:id',
		component: <UserCreateEdit />
	},
	{
		name: 'Settings',
		path: '/settings',
		component: <Settings />
	},
	{
		name: 'Ring Central',
		path: '/ring-central',
		component: <RingCentral />
	},
	{
		name: 'Calendar',
		path: '/calendars',
		component: <Calendar />
	},
	{
		name: 'TimeLogs',
		path: '/time-logs',
		component: <TimeLogs />
	},
	{
		name: 'MyProfile',
		path: '/profile',
		component: <MyProfile />
	},
	{
		name: 'Marketing Report',
		path: '/marketing-report',
		component: <WebsiteData />
	},
	{
		name: 'Lead Cost',
		path: '/lead-cost',
		component: <LeadCost />
	},
	{
		name: 'Dummy Report',
		path: '/dummy-report',
		component: <DummyReport />
	},
	{
		name: 'GA / GSC',
		path: '/google-reports',
		component: <GoogleReports />
	},
	{
		name: 'User Acquisition',
		path: '/google-reports/user-acquisition',
		component: <GoogleReportDetailPage />
	},
	{
		name: 'Events',
		path: '/google-reports/events',
		component: <GoogleReportDetailPage />
	},
	{
		name: 'Landing Pages',
		path: '/google-reports/landing-pages',
		component: <GoogleReportDetailPage />
	},
];

export const authCrewRoutes = [
	{
		name: 'Admin Dashboard',
		path: '/dashboard',
		component: <Dashboard />
	},
	{
		name: 'Ring Central',
		path: '/ring-central',
		component: <RingCentral />
	},
	{
		name: 'Calendar',
		path: '/calendars',
		component: <Calendar />
	},
	{
		name: 'MyProfile',
		path: '/profile',
		component: <MyProfile />
	}
];

export const authOperationsRoutes = [
	{
		name: 'Admin Dashboard',
		path: '/dashboard',
		component: <Dashboard />
	},
	{
		name: 'MyProfile',
		path: '/profile',
		component: <MyProfile />
	}
];

export const authEstimatorRoutes = [
	{
		name: 'Estimates',
		path: '/estimates',
		component: <Estimates />
	},
	{
		name: 'Estimates Templates',
		path: '/estimates/templates',
		component: <EstimatesTemplatesPage />
	},
	{
		name: 'Estimates Category',
		path: '/estimates/category',
		component: <EstimatesCategoryPage />
	},
	{
		name: 'Create Template',
		path: '/estimates/templates/create',
		component: <CreateTemplatePage />
	},
	{
		name: 'Edit Template',
		path: '/estimates/templates/edit/:id',
		component: <CreateTemplatePage />
	},
	{
		name: 'Admin Dashboard',
		path: '/dashboard',
		component: <Dashboard />
	},
	{
		name: 'MyProfile',
		path: '/profile',
		component: <MyProfile />
	}
];
